export const getBike = (state) => state.bike.items;
export const errorManufacturer = (state) => state.bike.items.manufacturer.error;
export const errorModel = (state) => state.bike.items.model.error;
export const errorPrice = (state) => state.bike.items.price.error;
export const errorDate = (state) => state.bike.items.boughtAt.error;
export const dealerInfo = (state) => state.bike.dealerInfo;
export const getStepOnboarding = (state) => state.bike.onboarding;
export const getStepInsurance = (state) => state.bike.insurance;
